import React, { useState, useEffect, useCallback, useRef } from "react";

const TYPE_SPEED = 60;
const DELETE_SPEED = 30;
const PAUSE_DURATION = 2000;

export default function TypewriterText({
  phrases = [],
  prefix = "",
  suffix = "",
  className = "",
  as: Tag = "span",
}) {
  const [displayed, setDisplayed] = useState("");
  const [phraseIndex, setPhraseIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const mountedRef = useRef(false);

  const currentPhrase = phrases[phraseIndex] || "";

  const safeSetIsDeleting = (v) => {
    if (mountedRef.current) setIsDeleting(v);
  };
  const safeSetPhraseIndex = (fn) => {
    if (mountedRef.current) setPhraseIndex(fn);
  };

  const tick = useCallback(() => {
    setDisplayed((prev) => {
      const target = currentPhrase;
      if (!isDeleting) {
        if (prev.length < target.length) {
          return target.slice(0, prev.length + 1);
        }
        return prev;
      } else {
        if (prev.length > 0) {
          return target.slice(0, prev.length - 1);
        }
        return prev;
      }
    });
  }, [currentPhrase, isDeleting]);

  useEffect(() => {
    mountedRef.current = true;
    const timeout = setTimeout(() => {
      if (!isDeleting && displayed === currentPhrase) {
        setTimeout(() => safeSetIsDeleting(true), PAUSE_DURATION);
        return;
      }
      if (isDeleting && displayed === "") {
        safeSetIsDeleting(false);
        safeSetPhraseIndex((prev) => (prev + 1) % phrases.length);
        return;
      }
      tick();
    }, isDeleting ? DELETE_SPEED : TYPE_SPEED);

    return () => {
      mountedRef.current = false;
      clearTimeout(timeout);
    };
  }, [displayed, isDeleting, currentPhrase, phrases.length, tick]);

  return (
    <Tag className={className}>
      {prefix}
      {displayed}
      <span className="inline-block w-0.5 h-5 ml-0.5 bg-current align-middle animate-pulse" />
      {suffix}
    </Tag>
  );
}
